/**
 * Generated by orval v8.5.2 🍺
 * Do not edit manually.
 * Alchemer Dashboard API
 * OpenAPI spec version: 1.0.155
 */

export type SharePermission = (typeof SharePermission)[keyof typeof SharePermission];

export const SharePermission = {
  MODIFY: 'MODIFY',
  NO_ACCESS: 'NO_ACCESS',
  READ_ONLY: 'READ_ONLY',
} as const;
